export default "__VITE_ASSET__DEJD6M6R__"